import { formatPriceToAR } from "../utils/utils";
import { VariationBig } from "../components/Variation";
import { __ } from "../locales/translation";

export default function ProductValueAndVar({ variationLabel, moneda, precioUltimo, variacion, clase }) {
    return (
        <div className="cot-product-value">
            {variationLabel && (
                <span className="tag var-label">
                    {__("VALOR CUOTA PARTE")} - {clase}
                </span>
            )}

            <div className="value-wrapper">
                <span className="small-text">{moneda || "-"}</span>{" "}
                <span className="title-3">{formatPriceToAR(precioUltimo) || ""}</span>
            </div>

            <VariationBig value={variacion} />
            {/* {item.variationType && <span className="small-text var-type">{item.variationType}</span>} */}
            <span className="small-text var-type">{__("Variación diaria")}</span>
        </div>
    );
}
